import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const deleteLot = (resource, id, lotId) => {
  return axios.delete(`/api/${resource}/${id}/setup/lots/${lotId}`);
};

export const useDeleteLot = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (lotId) => deleteLot(resource, id, lotId),
    onSuccess: () => {
      enqueueSnackbar('Lot successfully deleted', { variant: 'success' });
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(error?.response?.data?.description || error?.message || 'Some error occured', {
        variant: 'error',
      });
    },
  });
};
